import cs from "classnames";
import React from "react";
import {
	FaExclamationTriangle,
	FaInfo,
	FaTimes,
	FaTimesCircle
} from "react-icons/fa";
import { FormattedMessage, MessageDescriptor } from "react-intl";

import "./Toast.css";

const icons = {
	message: <FaInfo />,
	warning: <FaExclamationTriangle />,
	error: <FaTimesCircle />
};

interface ToastProps {
	variant: "message" | "warning" | "error";
	timeout: number;
	content: MessageDescriptor;
	onClose(): unknown;
}

export const Toast: React.FunctionComponent<ToastProps> = ({
	variant,
	timeout,
	content,
	onClose
}) => {
	const hasTimeout = timeout > 0 && timeout < Infinity;
	React.useEffect(() => {
		let t = 0;
		if (hasTimeout) {
			t = window.setTimeout(onClose, timeout);
		}
		return () => {
			window.clearTimeout(t);
		};
	}, [hasTimeout, timeout, onClose]);
	return (
		<div className={cs("toast", `toast--${variant}`)}>
			{hasTimeout && (
				<div
					className="toast__progress"
					style={{ animationDuration: `${timeout}ms` }}
				/>
			)}
			<div className="toast__body">
				<div className="toast__icon">{icons[variant]}</div>
				<div className="toast__content">
					<FormattedMessage {...content} />
				</div>
				<button className="toast__button" onClick={onClose}>
					<FaTimes />
				</button>
			</div>
		</div>
	);
};
